export default __webpack_public_path__ + "static/media/course.363f947d.svg";